<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="disassembleOrders">
        <div slot="toolbar">
          <el-button type="primary" @click="$refs.editPage.open(0)">
            新建
          </el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="申请编号">
              <el-input v-model.trim="filter.billNo" clearable/>
            </vm-search>
            <vm-search label="申请人">
              <el-input v-model.trim="filter.creatorName" clearable/>
            </vm-search>
            <vm-search label="退货单号">
              <el-input v-model.trim="filter.returnOrderNo" clearable/>
            </vm-search>
            <vm-search label="申请时间">
              <el-date-picker
                  v-model="createTime"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="createTimeChange"/>
            </vm-search>
            <vm-search label="客户名称">
              <el-input v-model.trim="filter.customerName" clearable/>
            </vm-search>
            <vm-search label="出厂编号">
              <el-input v-model.trim="filter.factoryNo" clearable/>
            </vm-search>
            <vm-search label="物流信息">
              <el-input v-model.trim="filter.logistics" clearable/>
            </vm-search>
            <vm-search label="退货单号">
              <el-input v-model.trim="filter.outStockNo" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column fixed="left" type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.details">
              <el-table-column prop="materialNo" align="center" label="物料编号"/>
              <el-table-column prop="materialName" align="center" label="物料名称"/>
              <el-table-column prop="quantity" align="center" label="数量"/>
              <el-table-column prop="unit" align="center" label="单位"/>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="billNo" width="160" align="center" label="申请编号">
          <template slot-scope="scope">
            <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</span>
            <el-button
                v-clipboard="scope.row.billNo"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                round
                icon="el-icon-chat-line-square"/>
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" align="center" label="申请人"/>
        <el-table-column prop="createTime" align="center" label="申请日期"/>
        <el-table-column prop="returnOrderNo" align="center" label="退料单号"/>
        <el-table-column prop="factoryNo" align="center" label="出厂编号"/>
        <el-table-column prop="dealType" align="center" label="处理类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.dealType===10" type="info">拆解</el-tag>
            <el-tag v-else-if="scope.row.dealType===20" type="success">利用</el-tag>
            <el-tag v-else type="danger">{{scope.row.dealType}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="disassemblyNo" align="center" label="拆解单号"/>
        <el-table-column prop="nodeDesc" width="140" align="center" label="当前节点"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button
                v-if="scope.row.status===0"
                type="primary"
                @click="$refs.editPage.open(scope.row.pkid)">
              编辑
            </el-button>
            <el-button
                v-if="scope.row.creatorId === currentId"
                type="danger"
                :disabled="scope.row.status!==0"
                @click="deleteRow(scope.row)">
              删除
            </el-button>
            <el-button
                v-if="scope.row.status===0"
                type="success"
                @click="submit(scope.row.pkid)">
              提交
            </el-button>
          </template>
        </el-table-column>
      </vm-table>
      <disassemble-order-edit ref="editPage" @save-success="getList(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";
  import DisassembleOrderEdit from "@/views/afterSalesManagement/DisassembleOrder/DisassembleOrderEdit";

  export default {
    name: "",
    components: {DisassembleOrderEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        currentId: loginUtil.getUserId(),
        ids: [],
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        createTime: "",
        filter: {
          returnOrderNo: "",
          customerName: "",
          factorNo: "",
          logistics: "",
          outStockNo: "",
          beginCreateTime: "",
          endCreateTime: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", "disassembleOrders/submit/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      select(selection) {
        this.ids = [];
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
      },
      deleteRow(row) {
        this.ids = [];
        this.ids.push(row.pkid);
        this.deleteRows();
      },
      clipboardSuccessHandler(e) {
        this.$message.success("复制单号成功");
      },
      clipboardErrorHandler(e) {
        this.$message.error("复制单号失败");
      },
      goto(row) {
        this.$router.push({
          path: "/DisassembleOrderPreview",
          query: {
            billType: 36,
            billId: row.pkid,
            $tabName: row.billNo,
          },
        });
      },
      deleteRows() {
        if (this.ids.length === 0) {
          this.$message.error("请先选择删除项");
          return;
        }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "disassembleOrders", this.ids)
            .then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        });
      },
    },
  };
</script>
<style scoped>
</style>
